export enum RenderToPaneKeys {
    DurationSecs = "DurationSecs",
    RenderedSuccessfully = "RenderedSuccessfully",
    RenderFailureReason = "RenderFailureReason",
    TriggerReason = "TriggerReason",
    IsShowingAudioFile = "IsShowingAudioFile",
    IsTranscriptEmpty = "IsTranscriptEmpty"
};